import {
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons';
import React, { useContext, useState } from 'react';
import { StoreContext } from '../../../store/store';
import styles from '../Style/LegendView.module.scss';

export default function LegendView() {
  const { legend } = useContext(StoreContext);
  const [showLegend, setShowLegend] = useState<boolean>(true);

  const values = legend.title.toLowerCase().includes('bathymetry')
    ? legend.values
    : legend.values.map((item) => item).reverse();
  
  return (
    <div className={`${styles.root}`}>
      <div className={styles.header} onClick={() => setShowLegend(!showLegend)}>
        <div className={styles.title}>{legend.name}</div>
        {showLegend ? (
          <UpOutlined className={`${styles.icon}`} />
        ) : (
          <DownOutlined className={`${styles.icon}`} />
        )}
      </div>
      {showLegend && (
        <div className={styles.content}>
          <div className={styles.contentTitle}>{'[' + legend.unit + ']'}</div>
          <div className={styles.contentValuesContainer}>
            {values.map((v, i) => (
              <div key={i} className={styles.contentValueItem}>      
                <div className={styles.number}>{v.value.toFixed(2)}</div>
                <div
                  style={{ backgroundColor: v.color }}
                  className={styles.colorBlock}
                ></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
